import { ProductDetails } from '../../types';

const RailcardProductRenderer = ({ name }: ProductDetails) => ({
  description: () => name,
});

export default (productDetails: ProductDetails) => RailcardProductRenderer(productDetails);
